import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'idp-view-search-options',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './view-search-options.component.html',
  styleUrls: ['./view-search-options.component.scss'],
  host: {
    tabindex: '-1'
  }
})
export class ViewSearchOptionsComponent {
  @Input() label = '';
  @Output() expand = new EventEmitter();
}
